// Self-host the Rive WASM runtimes (WebGL2 + Canvas2D) so we don't pull
// ~800KB from unpkg on every page load. Vite emits the .wasm into our own
// bundle and returns a hashed URL. Per Rive's preloading-wasm docs.
import riveWebgl2WasmUrl from '@rive-app/webgl2/rive.wasm?url';
import riveCanvasWasmUrl from '@rive-app/canvas/rive.wasm?url';
import { RuntimeLoader as Webgl2Loader } from '@rive-app/webgl2';
import { RuntimeLoader as CanvasLoader } from '@rive-app/canvas';

let initialized = false;
export function initRiveRuntime() {
  if (initialized) return;
  initialized = true;
  try { Webgl2Loader.setWasmUrl(riveWebgl2WasmUrl); } catch {}
  try { CanvasLoader.setWasmUrl(riveCanvasWasmUrl); } catch {}
}

initRiveRuntime();
